import { create } from "zustand";

export type ChatAccessState = {
  canEdit: boolean | null;
  isPublic: boolean | null;
};

interface ChatAccessStore {
  byChatId: Record<string, ChatAccessState>;
  setAccess: (chatId: string, access: Partial<ChatAccessState>) => void;
  resetChatAccess: (chatId: string) => void;
  resetAll: () => void;
}

const initialAccess: ChatAccessState = {
  canEdit: null,
  isPublic: null,
};

export const useChatAccessStore = create<ChatAccessStore>((set) => ({
  byChatId: {},

  setAccess: (chatId, access) =>
    set((state) => ({
      byChatId: {
        ...state.byChatId,
        [chatId]: {
          ...(state.byChatId[chatId] ?? initialAccess),
          ...access,
        },
      },
    })),

  resetChatAccess: (chatId) =>
    set((state) => {
      const next = { ...state.byChatId };
      delete next[chatId];
      return { byChatId: next };
    }),

  resetAll: () => set({ byChatId: {} }),
}));
